/* Dependencies */
import { matchSortFromType } from '../matchSort/matchSort';

// Models
import { Filter, SortBy } from '../../CoffeePicker.model';

/**
 * Update URL Params
 * @param filters - The acitve filters.
 * @param sort - The active sort.
 */
export const updateURLParams = (filters: Filter[], sort: SortBy): void => {
  const sortParam = matchSortFromType(sort);
  const filterParams: { [key: string]: string[] } = {};

  // Loop the filters and form the params object.
  filters.forEach((filter: Filter) => {
    const name = filter.name.split(' ').join('-').toLocaleLowerCase();
    if (!filterParams[filter.property]) {
      filterParams[filter.property] = [];
    }
    filterParams[filter.property].push(name);
  });

  // Form the filter string.
  let filterString = '';
  Object.keys(filterParams).forEach((key) => {
    filterString += `&${key}=${filterParams[key].join(',')}`;
  });

  // Update the history URL.
  window.history.replaceState(
    {},
    '',
    `?sort=${sortParam}${filterString ? filterString : ''}`
  );
};
